import React, { useState, useEffect } from 'react';
import { Modal, Space, Typography, Tooltip } from 'antd';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import {OpenInNewRounded, ExpandRounded, OpenWithRounded} from "@mui/icons-material";
import { FullscreenOutlined, ExpandAltOutlined } from '@ant-design/icons';
import { jsPDF } from 'jspdf';


const PdfPreview = ({ bucketUrl, width=200, height=260, title }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        const response = await fetch(bucketUrl);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        setPdfUrl(blobUrl);
      } catch (error) {
        console.error("Error fetching the PDF:", error);
      }
    };

    if (bucketUrl) {
      fetchPdf();
    }
  }, [bucketUrl]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const openInNewWindow = () => {
    window.open(pdfUrl, "_blank", "noopener,noreferrer");
  };

  return (
      <>
        <div style={{ position: 'relative', textAlign: 'left', padding: '10px' }}>
          {pdfUrl ? (
            <Space direction={'vertical'}>
              <ButtonGroup className={'px-1'}>
                <Tooltip title={'Expand in Current Tab'}>
                  <Button onClick={showModal} size={'small'}>
                    <OpenWithRounded fontSize={'small'}/>
                  </Button>
                </Tooltip>
                <Tooltip title={'Open in New Tab'}>
                  <Button onClick={openInNewWindow} size={'small'}>
                   <OpenInNewRounded fontSize={'small'}/>
                  </Button>
                </Tooltip>
              </ButtonGroup>
              <div onClick={showModal}
                   className={'cursor'}
              >
                <div style={{height, width, overflow: 'hidden'}}>
                  <iframe
                    src={`${pdfUrl}#toolbar=0&scrollbar=0&navpanes=0`}
                    width={width}
                    height={'100%'}
                    style={{ border: '0', borderRadius: '4px', boxShadow: 'none'}}
                    title="PDF Preview"
                    scrolling={'no'}
                  />
                </div>

              </div>
              <div style={{height: 30, width}}>
                <Tooltip title={title}>
                  <Typography.Text
                      ellipsis={{
                        rows: 2,
                        expanded: false
                      }}
                  >
                    {title || "Untitled.."}
                  </Typography.Text>
                </Tooltip>
              </div>

            </Space>
          ) : (
            <p>Loading PDF...</p>
          )}
        </div>
        <Modal
            title="PDF Fullscreen View"
            visible={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            width={600}
            style={{ top: 20, height: 900 }}
            bodyStyle={{ padding: 0 }}
          >
            <iframe
              src={pdfUrl}
              width="100%"
              height={800}
              style={{ border: 'none' }}
              title={title || "PDF Fullscreen"}

            ></iframe>
        </Modal>
      </>
  );

};

export default PdfPreview;
